import { useAuth } from '#context/Auth.tsx'
import { validatingFetch } from '#utils/validatingFetch.ts'
import { UserAccountResponse } from '@nrfcloud/account-service-proto/user'
import type { StaticDecode } from '@sinclair/typebox'
import { useEffect, useState } from 'preact/hooks'
import { Repeat } from './Repeat.tsx'
import { ValueLoading } from './ValueLoading.tsx'

export const TeamSelectorCard = () => {
	const { oidcUser } = useAuth()
	const [user, setUser] = useState<StaticDecode<typeof UserAccountResponse>>()

	useEffect(() => {
		if (oidcUser?.id_token === undefined) return
		validatingFetch(UserAccountResponse)(
			new URL(`/2025-06-30/user`, ACCOUNT_API_URL),
			undefined,
			'GET',
			{
				Authorization: oidcUser.id_token,
			},
		).ok(setUser)
	}, [oidcUser])

	return (
		<div class="card">
			<div class="card-body">
				<h5 class="card-title">Your teams</h5>
				<p class="card-text">
					Please select the team which you would like to manage.
				</p>
			</div>
			<ul class="list-group list-group-flush">
				{user === undefined && (
					<Repeat>
						<li class="list-group-item">
							<ValueLoading height={16} width={'100%'} />
						</li>
					</Repeat>
				)}
				{user !== undefined &&
					Object.entries(user.teams).map(([teamId, team]) => (
						<li class="list-group-item" key={teamId}>
							<a href={`/team/${teamId}`}>{team.name ?? teamId}</a>
						</li>
					))}
			</ul>
		</div>
	)
}
